import React, { useState } from 'react';
import Container from 'src/components/shared/Container';
import InterviewsContainer from 'src/components/interviews/InterviewsContainer';
import NoRoundScheduled from 'src/components/interviews/NoRoundScheduled';
import { useGetMeetingsQuery } from 'src/hooks/meeting.hooks';
import { Loader } from 'ui';
import seoConfig from '../../seo.json';
import Seo from 'src/components/Seo';
import { ScheduleInterviewDrawer } from 'src/components/scheduleMeetingDrawer';
import { sendTrackingEvent } from 'src/utils/gtm';
import { useLocation } from 'react-router-dom';
import NewCreatingPositionLoader from 'src/components/position/NewCreatingPositionLoader';
import AssessmentContainer from 'src/components/interviews/AssessmentContainer';
import { HiringAssessmentDocument } from 'types';
import GuestUserNavbar from './GuestUserNavbar';

const GuestUserAssessmentDashboard = () => {
	const location = useLocation();
	const { data, isLoading, isError } = useGetMeetingsQuery();
	const seoInfo = seoConfig['interviews-js'];
	const [isScheduleInterviewDrawerOpen, setIsScheduleInterviewDrawerOpen] = useState<boolean>(false);

	if (isLoading) {
		return (
			// <Loader />
			<NewCreatingPositionLoader showAnimation={true} progressBar={false} customClassCss="!w-[30%] mx-auto " />
		);
	}

	if (isError) {
		// render error screen
	}

	return (
		<>
			<GuestUserNavbar />
			<Seo title={seoInfo.title} description={seoInfo.description} />
			<Container>
				{(data?.meetings && data.meetings.length) ||
				(data?.nonCampusApplication && data?.nonCampusApplication?.length) ||
				(data?.campusApplication && data?.campusApplication?.length) ||
				(data?.hiringAssessments && data?.hiringAssessments?.length) ? (
					// <InterviewsContainer meetings={data.meetings} onClick={() => setIsScheduleInterviewDrawerOpen(true)} />
					<AssessmentContainer
						meetings={data.meetings}
						campusApplication={data?.campusApplication as unknown as HiringAssessmentDocument[]}
						nonCampusApplication={data?.nonCampusApplication as unknown as HiringAssessmentDocument[]}
						hiringAssessments={data?.hiringAssessments as unknown as HiringAssessmentDocument[]}
						onClick={() => setIsScheduleInterviewDrawerOpen(true)}
					/>
				) : (
					<div className="h-[calc(100vh-70px)] sm:h-[calc(100vh-140px)] min-h-[350px] flex flex-col items-center justify-center">
						<NoRoundScheduled
							onClick={() => {
								sendTrackingEvent({
									event: 'tech_round_kyl',
									eventLabel: location.pathname,
								});
								setIsScheduleInterviewDrawerOpen(true);
							}}
						/>
					</div>
				)}
			</Container>

			<ScheduleInterviewDrawer
				isOpen={isScheduleInterviewDrawerOpen}
				onClose={() => {
					sendTrackingEvent({
						event: 'interview_drawer_close',
						eventLabel: location.pathname,
					});

					setIsScheduleInterviewDrawerOpen(false);
				}}
			/>
		</>
	);
};

export default GuestUserAssessmentDashboard;
